import React from 'react'
import { FormControl, Grid, TextField, Typography } from '@mui/material'

export const BalanceInformationSection = ({useFetchInit}) => {

    const { 
        //------------- Generales
        // location,
        // paramsURL,
        //------------- globalStates
        // globalStates,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        // Actions,
        //------------- helpers
        // Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

    // ------------------------------------------------ Generales
        
    // ------------------------------------------------ globalStates
    // const {showFormContract, formOpeningMode} = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormRequestGlobal } = Forms
    const { formState, onInputChange } = FormRequestGlobal
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions

    const ordinary_total_balance = (parseFloat(formState.ordinary_total_debt) - parseFloat(formState.ordinary_total_exemption)) - parseFloat(formState.ordinary_total_paid)
    const extraordinary_total_balance = (parseFloat(formState.extraordinary_total_debt) - parseFloat(formState.extraordinary_total_exemption)) - parseFloat(formState.extraordinary_total_paid)
    const expense_total_balance = (parseFloat(formState.expense_total_debt) - parseFloat(formState.expense_total_exemption)) - parseFloat(formState.expense_total_paid)
    const total_balance = ordinary_total_balance + extraordinary_total_balance + expense_total_balance
    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Informacion sobre la gestion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="ordinary_total_debt"> * (ORD) Total adeudado</label>
                        <TextField
                            id='ordinary_total_debt'
                            name='ordinary_total_debt'
                            value={ formState.ordinary_total_debt } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Día de pago'
                            type='number'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="ordinary_total_exemption"> * (ORD) Total exonerado</label>
                        <TextField
                            id='ordinary_total_exemption'
                            name='ordinary_total_exemption'
                            value={ formState.ordinary_total_exemption } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Nuevo dia de pago'
                            type='number'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="ordinary_total_paid"> * (ORD) Total pagado</label>
                        <TextField
                            id='ordinary_total_paid'
                            name='ordinary_total_paid'
                            value={ formState.ordinary_total_paid } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Nuevo dia de pago'
                            type='number'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className="pt-1"></div>
            <div className="border-bottom border-light"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="extraordinary_total_debt"> * (EXT) Total adeudado</label>
                        <TextField
                            id='extraordinary_total_debt'
                            name='extraordinary_total_debt'
                            value={ formState.extraordinary_total_debt } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Día de pago'
                            type='number'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="extraordinary_total_exemption"> * (EXT) Total exonerado</label>
                        <TextField
                            id='extraordinary_total_exemption'
                            name='extraordinary_total_exemption'
                            value={ formState.extraordinary_total_exemption } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Nuevo dia de pago'
                            type='number'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="extraordinary_total_paid"> * (EXT) Total pagado</label>
                        <TextField
                            id='extraordinary_total_paid'
                            name='extraordinary_total_paid'
                            value={ formState.extraordinary_total_paid } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Nuevo dia de pago'
                            type='number'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className="pt-1"></div>
                <div className="border-bottom border-light"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="expense_total_debt"> * (GAS) Total adeudado</label>
                            <TextField
                                id='expense_total_debt'
                                name='expense_total_debt'
                                value={ formState.expense_total_debt } 
                                onChange={ onInputChange }
                                size='small'
                                placeholder='Día de pago'
                                type='number'
                                variant='filled'
                                hiddenLabel
                                InputProps={{
                                    readOnly: true 
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="expense_total_exemption"> * (GAS) Total exonerado</label>
                            <TextField
                                id='expense_total_exemption'
                                name='expense_total_exemption'
                                value={ formState.expense_total_exemption } 
                                onChange={ onInputChange }
                                size='small'
                                placeholder='Nuevo dia de pago'
                                type='number'
                                variant='filled'
                                hiddenLabel
                                InputProps={{
                                    readOnly: true 
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
                        <FormControl fullWidth>
                            <label htmlFor="expense_total_paid"> * (GAS) Total pagado</label>
                            <TextField
                                id='expense_total_paid'
                                name='expense_total_paid'
                                value={ formState.expense_total_paid } 
                                onChange={ onInputChange }
                                size='small'
                                placeholder='Nuevo dia de pago'
                                type='number'
                                variant='filled'
                                hiddenLabel
                                InputProps={{
                                    readOnly: true 
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            <div className="pt-1"></div>
            <div className="border-bottom border-light"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                    <Typography variant="h4" align="center" gutterBottom>
                        <b>SALDO TOTAL Q {total_balance}</b>
                    </Typography>
                    <Typography variant="body1" align="center" gutterBottom>
                        (total adeudado - total exonerado ) - total pagado = saldo total
                    </Typography>
                </Grid>
            </Grid>
        </>
    )
}
